import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  error: {
    id: 'studio.yjZtkP',
    defaultMessage: 'There was a problem loading the apps. Please try reloading the page.',
  },
  import: {
    id: 'studio.9XUYQt',
    defaultMessage: 'Import',
  },
  importFile: {
    id: 'studio.pr6SmF',
    defaultMessage: 'Import from file',
  },
  noFile: {
    id: 'studio.utbyMo',
    defaultMessage: 'Please select a file',
  },
  nameConflict: {
    id: 'studio.cMpxYy',
    defaultMessage: 'An app with this name already exists in this organization.',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  organization: {
    id: 'studio.K56Dim',
    defaultMessage: 'Organization',
  },
  submit: {
    id: 'studio.wSZR47',
    defaultMessage: 'Submit',
  },
});
